import React from 'react';
import { useQuery, useApolloClient } from '@apollo/client';
import Button from '@blaze-react/button';
import { GET_USER_EBOOKS, GET_USER_EBOOK_REDIRECT } from './application/queries';

const MyEbooks = ({ limit = 4 }) => {
  const {
    data: { ebooks = [] } = {},
    loading,
    error,
    fetchMore
  } = useQuery(GET_USER_EBOOKS, {
    context: { credentials: 'include' },
    fetchPolicy: 'cache-and-network'
  });

  const client = useApolloClient();

  if (loading || error || !ebooks.length) return null;

  const openEbook = async (token, event) => {
    event.preventDefault();
    const { data } = await client.query({
      query: GET_USER_EBOOK_REDIRECT,
      variables: { token }
    });

    if (data?.getUserEbookRedirect?.url) {
      window.open(data.getUserEbookRedirect.url, '_blank');
    }
  };

  const shouldShowLoadMore = ebooks.length % limit === 0;

  const fetchMoreEbooks = () => {
    fetchMore({
      variables: {
        offset: limit
      },
      updateQuery(previousData, { fetchMoreResult, variables: { offset } }) {
        if (!fetchMoreResult) return previousData;

        return {
          ebooks: offset
            ? Array.from(
                new Map(
                  [...previousData.ebooks, ...fetchMoreResult.ebooks].map(item => [item.id, item])
                ).values()
              )
            : fetchMoreResult.ebooks
        };
      }
    });
  };

  return (
    <div className="user-ebook-list">
      <div className="list list--compact">
        <div className="grid grid--four">
          {ebooks.map(ebook => (
            <div className="list__item list__item--compact">
              <div className="card card--portrait">
                <div className="card__image card__image--portrait">
                  <a
                    aria-label={`Open ${ebook.product.name}`}
                    className="card__image-link"
                    data-gtm-id="list-products"
                    role="button"
                    href="/#"
                    onClick={event => openEbook(ebook.token, event)}>
                    <span />
                    <img
                      alt={ebook.product.name}
                      className="card__image-link__image"
                      src={ebook.product.image?.url}
                    />
                  </a>
                </div>
                <div className="card__content-wrapper card__content-wrapper--portrait ">
                  <div className="card__content card__content--portrait">
                    <div className="card__title card__title--portrait ">
                      <a
                        aria-label={ebook.product.name}
                        data-gtm-id="list-products"
                        href="/#"
                        onClick={event => openEbook(ebook.token, event)}>
                        {ebook.product.name}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {shouldShowLoadMore && (
        <Button className="button button--left" onClick={fetchMoreEbooks}>
          Show more ebooks
        </Button>
      )}
    </div>
  );
};

export default MyEbooks;
